module.exports = __webpack_public_path__ + "img/icon-map-implantation-10.8e1004cd.svg";